import { combineReducers } from 'redux';

import integration from './integration';

/**
 * @typedef {{
 *  integration: import('./integration').DealerConfigurationAdministrationIntegrationUIReducer,
 * }} DealerConfigurationAdministrationUIReducer
 */

export default combineReducers({
  integration,
});
